import { Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { formatMessage } from '../../../translations/format-message';
import {
  BatchModeIcon, SingleModeIcon
} from '../../../shared-components/svgs/svgs';

interface ModeSelectionModalProps {
  show: boolean;
  onModalClosed: () => void;
  onSelectMode: (isBatch: boolean) => void;
  handleBackClick: () => void;
}

const ModeSelectionModal = (props: ModeSelectionModalProps) => {
  const { show, onModalClosed, onSelectMode } = props;

  const handleSingleModeSelect = () => {
    onSelectMode(false);
    onModalClosed();
  };

  const handleBatchModeSelect = () => {
    onSelectMode(true);
    onModalClosed();
  };

  return (
    <Modal
      className="mode-selection-modal fancy-modal"
      size="lg"
      show={show}
      centered
      onHide={() => {}}
    >
      <Modal.Header>
        <Modal.Title>
          <button
            onClick={props.handleBackClick}
            className="btn btn-sm btn-secondary me-3"
          >
            <FormattedMessage id="back" />
          </button>
          <FormattedMessage id="select_mode" />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row g-3 py-5 justify-content-around">
          <div className="col-md-4 col-6">
            <div
              className="card  btn btn-light-red h-100 cursor-pointer border-primary"
              onClick={handleSingleModeSelect}
              style={{ cursor: 'pointer' }}
            >
              <div className="card-body text-center">
                <div className="mb-3">
                  <SingleModeIcon />
                </div>
                <h4 className="mb-0">{formatMessage('single_mode')}</h4>
                <p className="card-text small text-muted">
                  {formatMessage('single_mode_description')}
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-6">
            <div
              className="card h-100 cursor-pointer border-success"
              onClick={handleBatchModeSelect}
              style={{ cursor: 'pointer' }}
            >
              <div className="card-body text-center">
                <div className="mb-3">
                  <BatchModeIcon />
                </div>
                <h4 className="mb-0">{formatMessage('batch_mode')}</h4>
                <p className="card-text small text-muted">
                  {formatMessage('batch_mode_description')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModeSelectionModal;
